// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"gdfedY","icon":"_37ZIa-","allWhite":"bVZZpR","brand":"_2J9CDI","allBrand":"_25rAT6","black":"_3aemqK"};